<template>
  <div>
    <h1>Payment Status</h1>
    <v-stepper v-if="paymentStatus && paymentStatus.status == 'OK'" v-model="step" alt-labels flat>
      <v-stepper-header>
        <v-stepper-step complete step="1">Confirm</v-stepper-step>
        <v-divider />
        <v-stepper-step :complete="paymentStatus && paymentStatus.status == 'OK'" step="2">Pay</v-stepper-step>
        <v-divider />
        <v-stepper-step step="3">Get Started</v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <p>
      
    </p>
    <v-alert v-if="paymentFailed" type="error" tile>
      <p>Payment failed. Please try again.</p>
      <p>
        <!-- <v-btn @click="window.history.go(-1);">Try again</v-btn> -->
      </p>
    </v-alert>
    <div v-if="paymentStatus && paymentStatus.status == 'OK'">
      <v-alert type="success" tile>
        <p>Thanks! Your order was successfully paid and processed.</p>
      </v-alert>

      <p>
        We have created an organization page for you which allow you to get started and create your first event.
      </p>
      <div v-if="orgLicense && orgLicense.unassigned_support_plans">
        <h3>Schedule Onboarding Call</h3>
        <p>You can now schedule your onboarding call. We will reach out to you within the next few business days.</p>
        <p>Don't want to wait?</p>
        <p><v-btn color="primary" to="/r/go/book-onboarding" target="_blank">Schedule onboarding call</v-btn> or reach out to your CSM directly.</p>
      </div>
      <div>
        <h3>Create event now</h3>
        <p>You can get started and prepare your first event now.</p>
        <p><v-btn large color="primary" :to="{ name: 'eventmanagerCreate', query: { groupId: $route.query.orgId, assign: 'auto' }}">Create Event</v-btn></p>
      </div>
      <div>
        <h3>Create at a later time</h3>
        <p>Alternatively, you can always come back later and create an event from your organization panel.</p>
        <p><v-btn outlined color="primary" :to="{ name: 'orgmanagerView', params: { id: $route.query.orgId }}">Open Organization Panel</v-btn></p>
      </div>

    </div>
    <v-alert v-if="paymentStatus && paymentStatus.status == 'ERROR'" type="success" tile>
      <p>{{ paymentStatus.msg }}</p>
    </v-alert>
    <v-alert v-if="!paymentFailed && (!paymentStatus || paymentStatus.status == 'ONGOING')" type="success" tile>
      <v-progress-circular indeterminate :size="25" :width="5" color="white" class="mr-4"></v-progress-circular>
      Loading payment status... One minute...
    </v-alert>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { EventBus } from '@/plugins/eventbus.js';
import checkoutService from "@/services/checkoutService";
import orgManagerService from "@/services/orgManagerService";

export default {
  name: "Status",
  props: {
  },
  data: function() {
    return {
      step: 3,
      paymentStatus: null,
      sessionId: null,
      orgId: null,
      orgLicense: null,
    };
  },
  async mounted() {
    this.sessionId = this.$route.query.sessionId;
    this.orgId = this.$route.query.orgId;
    this.getPaymentStatus();
    
    EventBus.$on('login-state-change', async user => {
      await this.getOrgLicense();
    });
    await this.getOrgLicense();
  },
  methods: {

    async getPaymentStatus() {
      if (!this.sessionId) {
        return;
      }

      this.paymentStatus = (await checkoutService.getSessionStatus(this.sessionId)).data;

      if (this.paymentStatus.status === 'ONGOING') {
        // schedule a next refresh in a few seconds
        setTimeout(this.getPaymentStatus, 5 * 1000);
      }
      if (this.paymentStatus.status === 'OK') {
        if (this.$route.query.redirect === 'clone-event' && this.$route.query.relatedEventId) {
          this.$router.push({ name: "eventmanagerClone", params: { id: this.$route.query.relatedEventId } });
        }
      }
    },

    async getOrgLicense() {
      if (!this.orgId || !this.user) {
        return;
      }

      var keepPolling = true;
      try {
        this.orgLicense = (await orgManagerService.getLicenseStatus(this.orgId)).data;
        if (this.orgLicense && (this.orgLicense.unassigned_users || this.orgLicense.unassigned_support_plans)) {
          keepPolling = false;
        }
      }
      catch {}

      if (keepPolling) {
        // schedule a next refresh in a few seconds
        setTimeout(this.getOrgLicense, 5 * 1000);
      }
    },

  },
  computed: {
    paymentFailed() {
      return this.$route.query.status=='cancelled';
    },
    ...mapGetters({
      user: "user"
    })
  },
};
</script>

<style scoped>
</style>